export default __webpack_public_path__ + "static/media/inspirationoff.f435a661.svg";